import { documentReady } from './utils';
//TODO: rewrite from js to styles classes

const FitToScreenBorder = {
    initialize: () => {
        documentReady(() => {
            document.querySelectorAll('.js-fit-to-right-border').forEach(item => {
                FitToScreenBorder.setElemW(item, 'right');
            });
            document.querySelectorAll('.js-image-to-left-border').forEach(item => {
                FitToScreenBorder.setElemW(item, 'left');
            });
        });
        window.addEventListener('resize', () => {
            document.querySelectorAll('.js-fit-to-right-border').forEach(item => {
                FitToScreenBorder.setElemW(item, 'right');
            });
            document.querySelectorAll('.js-image-to-left-border').forEach(item => {
                FitToScreenBorder.setElemW(item, 'left');
            });
        });
    },

    setElemW : (item, direction) => {
        if(direction === 'right') {
            //Image to the right
            item.style.marginRight = ''; //reset property to calc

            let offsetL = item.getBoundingClientRect().left + document.body.scrollLeft;
            let offsetR = offsetL + parseFloat(getComputedStyle(item, null).width.replace("px", ""));
            let windowW = parseFloat(getComputedStyle(document.body, null).width.replace("px", ""));
            let availableW = windowW - offsetR;
            let img = item.querySelector('img');

            item.style.marginRight = '-'+availableW+'px';
            if (img) {
                img.style.width = '100%';
            }
        } else if (direction === 'left') {
            //Image to the left
            item.style.marginLeft = ''; //reset property to calc

            let offsetL = (item.getBoundingClientRect().left + document.body.scrollLeft);
            let img = item.querySelector('img');

            item.style.marginLeft = '-'+offsetL+'px';
            if (img) {
                img.style.width = '100%';
            }
        }
    },
}

FitToScreenBorder.initialize();

export default FitToScreenBorder;
